import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/components/cert-number-modal/关闭弹窗.png")